import { Trans } from '@lingui/macro'
import { Box, Breadcrumbs } from '@mui/material'
import { PlatformRoute, toRoutingConfigObject } from '@om1/cohort-module'
import { InsightsLibraryRoutes } from '@om1/insights-library-module'
import { Routes } from '@om1/platform-routing'
import { BreadcrumbLink, ContentContainerStyle } from '@om1/platform-ui-kit/src/components/Layout'
import { PlatformPermissions } from '@om1/platform-utils'
import React from 'react'
import { Redirect, Route, Switch, useLocation, useRouteMatch } from 'react-router-dom'
import { AccessDeniedPage } from '../../../../apps/platform/src/pages/AccessDeniedPage'
import { createPermissionProtectedRouteComponent } from '../../../../apps/platform/src/pages/PermissionProtectedRoute'
import { PlatformState } from '../../../../apps/platform/src/platform-state'
import { createManageInsightsLibraryPage } from './ManageInsightsLibraryPage'
import { createPowerBIPageComponent } from './PowerBIPage'

const PowerBIPage = createPowerBIPageComponent<PlatformState>()
const ManageInsightsLibraryPage = createManageInsightsLibraryPage<PlatformState>()

export const InsightsLibraryPage: React.FunctionComponent = () => {
    const match = useRouteMatch()
    const location = useLocation()

    if (!match) {
        return null
    }
    const { path: matchPathValue, url: matchUrlValue } = match

    // Check if we're on the manage route
    const isManagePage = location.pathname.includes('/manage')

    const routes: PlatformRoute[] = [
        {
            route: InsightsLibraryRoutes.BASE,
            component: PowerBIPage,
            permissions: [PlatformPermissions.ACCESS_COHORTS]
        },
        {
            route: InsightsLibraryRoutes.MANAGE,
            component: ManageInsightsLibraryPage,
            permissions: []
        }
    ]

    const PermissionProtectedRoute = createPermissionProtectedRouteComponent<PlatformState>()

    const routingConfigObject = toRoutingConfigObject(routes, matchPathValue, matchUrlValue)

    const pages = (
        <Switch>
            {routingConfigObject.map((tab) => {
                const { route, component, permissions } = tab
                return (
                    <Route key={`route-${route}`} {...tab.matchRoute} exact={true}>
                        <PermissionProtectedRoute
                            permissions={permissions}
                            accessDeniedComponent={<AccessDeniedPage />}
                            protectedChild={React.createElement(component)}
                        />
                    </Route>
                )
            })}
            <Redirect key='insightsRedirect' to={routingConfigObject[0].url} />
        </Switch>
    )

    return (
        <ContentContainerStyle>
            {/* Breadcrumb Navigation - Only show for manage page */}
            {isManagePage && (
                <Box sx={{ mt: 3, ml: 3, mb: 2 }}>
                    <Breadcrumbs separator='›' aria-label='breadcrumb'>
                        <BreadcrumbLink to={`/${Routes.HOME}`} sx={{ fontWeight: '600', fontSize: '16px', color: '#012D72' }}>
                            <Trans>Home</Trans>
                        </BreadcrumbLink>
                        <BreadcrumbLink to={`/${Routes.INSIGHTS_LIBRARY}`} sx={{ fontWeight: '600', fontSize: '16px', color: '#012D72' }}>
                            <Trans>Insights Library</Trans>
                        </BreadcrumbLink>
                        <Box sx={{ fontWeight: '600', fontSize: '16px', color: '#707171' }}>
                            <Trans>Manage</Trans>
                        </Box>
                    </Breadcrumbs>
                </Box>
            )}
            {pages}
        </ContentContainerStyle>
    )
}
